import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';

const Header: React.FC = () => {
  const { isAuthenticated, user, logout, loginWithRedirect } = useAuth0();

  return (
    <header className="app-header">
      <h1>Job Seeker</h1>
      
      {isAuthenticated ? (
        <div className="user-info">
          {user?.picture && <img src={user.picture} alt={user.name || 'User'} />}
          <span>{user?.name}</span>
          <button onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}>
            Log Out
          </button>
        </div>
      ) : (
        <button onClick={() => loginWithRedirect()}>Log In</button>
      )}
    </header>
  );
};

export default Header;